import React from "react";
import JourneyMilestoneFormPage from "../components/journey-milestones/JourneyMilestoneFormPage";

const JourneyMilestoneEdit = () => <JourneyMilestoneFormPage mode="edit" />;

export default JourneyMilestoneEdit;
